import {connect} from 'react-redux'
import PasswordChangeForm from '../component/PasswordChangeForm'
import {passwordChange as action} from 'redux/actions/actions'
import {passwordChange as thunk} from 'redux/actions/thunks'
import withReduxForm from 'app/common/hoc/redux-form/ReduxForm'

const mapStateToProps = (state) => {
  return {
    ...state.passwordChangeReducer
  }
}

const mapDispatchToProps = (dispatch) => {
  return {}
}

export default withReduxForm(mapStateToProps, mapDispatchToProps, action, thunk)(PasswordChangeForm)
